// شارة عرض الوحدة بجانب اسم الحقل — لتوضيح مثل ($, %, توكن, صورة, ...) بشكل ثابت.
export const UnitLabel = ({ text, unit }) => (
  <p className="label-xs mb-1 flex items-center justify-between gap-2">
    <span>{text}</span>
    {unit ? (
      <span className="rounded-full bg-background px-2 py-0.5 text-[10px] font-bold text-muted-foreground shadow-neu-in"
            data-testid="unit-badge">
        {unit}
      </span>
    ) : null}
  </p>
);
